import React from 'react';
import { DemoEnvironmentBanner } from '../demo/DemoEnvironmentBanner';
import { DemoSidebar } from './DemoSidebar';
import { Sidebar } from './Sidebar';
import { AppNavbar } from './AppNavbar';
import useDemoSandbox from '../../hooks/useDemoSandbox';
import { ShellNavProvider } from '../../contexts/ShellNavContext';

interface DashboardLayoutProps {
  children: React.ReactNode;
}

/**
 * App shell (sidebar + navbar + main).
 * PageTitleProvider lives at App root — not here — so pages can call usePageTitle()
 * before returning this layout.
 */
export const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  const sandbox = useDemoSandbox();

  return (
    <ShellNavProvider>
      <div className="min-h-screen bg-slate-50">
        {sandbox ? <DemoSidebar /> : <Sidebar />}
        <div className="flex flex-1 flex-col md:pl-64">
          {sandbox && <DemoEnvironmentBanner />}
          <AppNavbar sandbox={sandbox} />
          <main className="relative flex-1">
            <div
              className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_55%_45%_at_95%_0%,hsl(285_60%_94%/0.9),transparent_58%)]"
              aria-hidden
            />
            <div className="relative flex-1 overflow-x-hidden py-4 md:py-5 text-neutral-900">
              <div className="mx-auto max-w-[1600px] px-3 sm:px-4 md:px-6">{children}</div>
            </div>
          </main>
        </div>
      </div>
    </ShellNavProvider>
  );
};

export default DashboardLayout;
